import { useCallback } from 'react';

import { useMutation } from '@apollo/client/react';

import {
  NewHitDocument,
  NewHitMutationVariables,
} from './Event.mutation.generated';

export const useLiveNewHit = () => {
  const [runMutation, status] = useMutation(NewHitDocument, {
    context: { role: 'anonymous' },
  });

  const execute = useCallback(
    (variables: NewHitMutationVariables) => {
      return runMutation({
        variables,
      });
    },
    [runMutation]
  );

  return { execute, status };
};
